import { createSimpleStore } from 'react-simple-reducer'
import { ModuloModel } from '../models/ModuloModel'
import api, { IQueryParams, ICounter } from '../api'

export interface IRequest {
  errorCode: number
  message: string
  fetching: boolean
}

export interface IModulosState {
  modulos?: ModuloModel[]
  modulosCount: number
  request: IRequest
  query?: IQueryParams
}

export const initialState: IModulosState = {
  modulos: [],
  modulosCount: 0,
  request: {
    fetching: false,
    errorCode: null,
    message: '',
  },
  query: { limit: 10, offset: 0 },
}

const modulosStore = createSimpleStore(
  initialState,
  {
    requestAsync(state) {
      state.request = {
        ...initialState.request,
        fetching: true,
      }
    },
    requestClean(state) {
      state.request = initialState.request
    },
    requestError(state, payload: Partial<IRequest>) {
      state.request = {
        errorCode: payload.errorCode,
        message: payload.message,
        fetching: false,
      }
    },
    modulosGetSuccess(state, payload: ICounter<ModuloModel>) {
      state.modulos = payload.rows
      state.modulosCount = payload.count
      state.request = initialState.request
    },
    modulosCreateOrUpdateSuccess(state, payload: ModuloModel) {
      state.modulos = state.modulos.filter((c) => payload.id !== c.id)
      state.modulos.push(payload)
    },
    modulosDeleteSuccess(state, payload: { id: number }) {
      state.modulos = state.modulos.filter((c) => +c.id !== payload.id)
    },
    setQueryParams(state, payload: IQueryParams) {
      state.query = { ...state.query, ...payload }
    },
  },
  {
    thunks: {
      updatePagination: (cursoId: number, query: IQueryParams) => (dispatch, getState) => {
        dispatch(modulosStore.actions.setQueryParams(query))
        modulosStore.thunks.modulosFetch({ cursoId })(dispatch, getState)
      },
      modulosFetch: ({ cursoId }: { cursoId: number }) => async (dispatch, getState) => {
        dispatch(modulosStore.actions.requestAsync())
        try {
          const modulos = await api.Modulos.get(getState().query, cursoId)
          dispatch(modulosStore.actions.modulosGetSuccess(modulos))
        } catch (error) {
          dispatch(modulosStore.actions.requestError({ errorCode: 400, message: 'Falha a consultar modulos' }))
        }
      },
      deleteModulo: (id: number) => async (dispatch) => {
        dispatch(modulosStore.actions.requestAsync())
        try {
          await api.Modulos.delete(id)
          dispatch(modulosStore.actions.modulosDeleteSuccess({ id }))
        } catch (error) {
          dispatch(modulosStore.actions.requestError({ errorCode: 400, message: 'Falha ao remover modulo' }))
        }
      },
      createOrUpdateModulos: (values: Partial<ModuloModel>) => async (dispatch) => {
        try {
          if (!values.moduloPrecedenteId) values.moduloPrecedenteId = null
          const modulo = await api.Modulos.post(values)
          dispatch(modulosStore.actions.modulosCreateOrUpdateSuccess({ ...modulo }))
          return modulo
        } catch (e) {
          dispatch(modulosStore.actions.requestError({ errorCode: 400, message: 'Falha ao salvar o modulo' }))
          throw e
        }
      },
    },
  }
)

export { modulosStore }
export const { Provider: ModulosProvider, useDispatch: useModulosDispatch, useState: useModulosState, useSelector: useModulosSelector } = modulosStore
